// BarraImpersonacion.js
// Banner fijo arriba de la app cuando el superadmin está "viendo como" el
// Administrador de otro tenant. Autónomo: lee su propio estado de
// localStorage (a propósito, no sessionStorage: tiene que sobrevivir a
// cerrar el navegador, porque la sesión de Supabase impersonada también
// sobrevive -- si no, se puede quedar navegando como el Administrador de
// un cliente sin ningún indicio visual) y no necesita props ni engancharse
// al estado de App.js.
// El registro expira a las 24hs de iniciado (EXPIRACION_MS, usa el mismo
// iniciado_en que ya guardaba SuperAdmin.js): pasado ese tiempo se cierra
// la sesión impersonada por completo (signOut + reload a Login) en vez de
// solo ocultar el banner, para no dejar una sesión de Administrador de
// cliente activa e invisible en la máquina del superadmin si se olvida de
// apretar "Salir".
// Integración: importar y renderizar <BarraImpersonacion/> una sola vez,
// arriba de todo, en App.js.
import { useState, useEffect } from "react";
import { supabase } from "./supabase";

const EXPIRACION_MS = 24 * 60 * 60 * 1000;

export default function BarraImpersonacion() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const raw = localStorage.getItem("alqos_impersonando");
        if (!raw) return;
        const data = JSON.parse(raw);
        const iniciadoEn = new Date(data.iniciado_en).getTime();
        if (!iniciadoEn || Date.now() - iniciadoEn > EXPIRACION_MS) {
          localStorage.removeItem("alqos_impersonando");
          localStorage.removeItem("alqos_sesion_superadmin");
          await supabase.auth.signOut();
          window.location.reload();
          return;
        }
        setInfo(data);
      } catch { /* noop */ }
    })();
  }, []);
  if (!info) return null;
  const salir = async () => {
    try {
      const raw = localStorage.getItem("alqos_sesion_superadmin");
      if (raw) {
        const { access_token, refresh_token } = JSON.parse(raw);
        await supabase.auth.setSession({ access_token, refresh_token });
      }
    } catch (e) {
      console.error("Error volviendo a la sesión de superadmin:", e);
    }
    localStorage.removeItem("alqos_impersonando");
    localStorage.removeItem("alqos_sesion_superadmin");
    window.location.reload();
  };
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 99999,
      background: "#f59e0b", color: "#1a1a1a", padding: "8px 16px",
      display: "flex", alignItems: "center", justifyContent: "center", gap: "14px",
      fontSize: "13px", fontWeight: "700", boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    }}>
      <span>🎭 Viendo ALQOS como Administrador de "{info.tenant_nombre}" ({info.admin_email})</span>
      <button onClick={salir} style={{
        background: "#1a1a1a", color: "white", border: "none", borderRadius: "8px",
        padding: "4px 14px", fontSize: "12px", fontWeight: "700", cursor: "pointer",
      }}>Salir</button>
    </div>
  );
}
